import { Directive, ElementRef, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
import { isInViewport } from '@df/dom/fn/is-in-viewport';
import { WINDOW } from '@df/dom/globals';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription, fromEvent, merge } from 'rxjs';

@Directive({
    selector: '[scrollAnimation]',
    standalone: true
})
export class ScrollAnimationDirective implements OnInit, OnDestroy {

    @Input('scrollAnimation')
    scrollAnimation?: boolean;

    @Input() startValue: number = 150;

    protected subscriptions: Subscription = new Subscription();

    private window = inject(WINDOW);

    constructor(
        private element: ElementRef,
        private client: Client,
        private timeoutService: TimeoutService,
        private readonly app: App
    ) { }


    ngOnInit(): void {
        if (!this.scrollAnimation) {
            return;
        }

        this.init()

        const root: Window | Element = this.client.scrollElementForEvents;

        this.subscriptions.add(
            merge(
                fromEvent(root, 'scroll'),
                fromEvent(root, 'touchmove')).subscribe(() => {
                    if (isInViewport(this.element.nativeElement, 0, "top")) {
                        this.animate();
                    }
                })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions?.unsubscribe();
    }

    init(): void {
        this.app.isPlatformBrowser && this.timeoutService.setTimeout(() => {
            if (!(isInViewport(this.element.nativeElement, 0, "top"))) {
                this.element.nativeElement.style.transform =
                    "translateY(" + this.startValue + "px)";
            }
        }, 500)
    }

    animate(): void {

        const rect = this.element.nativeElement.getBoundingClientRect();
        const windowHeight = this.window.innerHeight;

        // current position of the element relative to the bottom of the window
        const difference = Math.floor(windowHeight - rect.top);

        let newValue = Math.floor(this.startValue - difference);

        // value can't less than 0
        if (newValue < 0) {
            newValue = 0;
        }

        this.element.nativeElement.style.transform =
            "translateY(" + newValue + "px)";
    }
}
